import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SquirrelEnvironmentDto } from 'projects/shared/src/lib/models/SquirrelEnvironmentDto';
import { DatabaseMigrationService } from 'projects/shared/src/lib/services/database-migration.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'update-squirrel-environment-dialog',
  templateUrl: './update-squirrel-environment-dialog.component.html',
  styleUrls: ['./update-squirrel-environment-dialog.component.css']
})
export class UpdateSquirrelEnvironmentDialogComponent implements OnInit {

  squirrelEnvironmentForm!: FormGroup;
  environmentDto!: SquirrelEnvironmentDto;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<UpdateSquirrelEnvironmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private databaseMigrationService: DatabaseMigrationService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log(this.data)
    this.createsquirrelEnvironmentForm();
  }

  createsquirrelEnvironmentForm() {
    this.squirrelEnvironmentForm = this.fb.group({
      id: [this.data.id],
      name: [this.data.name],
      url: [this.data.url],
      // numberOfMigrations: [this.data.numberOfMigrations],
      // migratedWhen: [this.data.migratedWhen]
    });
  }

  update() {  
    if(this.squirrelEnvironmentForm.valid) {

      let environmentDto = new  SquirrelEnvironmentDto;
      
      environmentDto.id = this.squirrelEnvironmentForm.value.id;
      environmentDto.name = this.squirrelEnvironmentForm.value.name;
      environmentDto.url = this.squirrelEnvironmentForm.value.url;
      // environmentDto.migratedWhen = this.squirrelEnvironmentForm.value.migratedWhen;
      // environmentDto.numberOfMigrations = this.squirrelEnvironmentForm.value.numberOfMigrations;

      console.log(environmentDto);

      this.databaseMigrationService.updateSquirrelEnvironment(environmentDto).subscribe({
        next: (data) => {          
        }
      });      
      this.dialogRef.close(this.squirrelEnvironmentForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}

